// extracted by mini-css-extract-plugin
module.exports = {"checker":"AllChecker_checker__1_VNK","checkbox":"AllChecker_checkbox__3bscr"};